import React, { FunctionComponent, useState } from 'react';
import Select from '../../../../global/atoms/Select';
import Input from '../../../../global/atoms/Input';
import Button from '../../../../global/atoms/Button';

interface ISelectDistrict {
  form: any;
  data: any;
  setData: any;
  errors: any;
  state: any;
  setState: any;
}

const SelectDistrict: FunctionComponent<ISelectDistrict> = ({ form, errors, setData, data, setState, state }) => {
  const [localState, setLocalState] = useState<{
    newInputVisible: boolean;
  }>({
    newInputVisible: false,
  });

  const handleShowNewInput = () => {
    setState({ ...state, ...{ newDistrictName: '' } });
    setLocalState({ ...localState, ...{ newInputVisible: !localState.newInputVisible } });
  };

  return (
    <>
      {!localState.newInputVisible && (
        <Select
          placeholder={'Powiat'}
          name={'district'}
          value={data.district}
          options={form.districts.options}
          disabled={false}
          state={data}
          setState={setData}
          errors={errors}
          limit={100}
        />
      )}
      <div style={{ display: 'block' }}>
        {localState.newInputVisible && (
          <Input
            type={'text'}
            placeholder={'Nowy powiat'}
            name={'newDistrictName'}
            value={state.newDistrictName}
            state={state}
            setState={setState}
            errors={errors}
          />
        )}
        <Button onClick={handleShowNewInput}>{localState.newInputVisible ? 'Anuluj' : 'Dodaj nowy'}</Button>
      </div>
    </>
  );
};

export default SelectDistrict;
